import ActionModel from 'cio/models/action';
import delay from 'cio/app-models/action-abstracts/delay';
import message from 'cio/app-models/action-abstracts/message';
import split from 'cio/app-models/action-abstracts/split';
import waitUntil from 'cio/app-models/action-abstracts/wait-until';
import timeWindow from 'cio/app-models/action-abstracts/time-window';
import manualSegmentUpdate from 'cio/app-models/action-abstracts/manual-segment-update';
import multiSplit from 'cio/app-models/action-abstracts/multi-split';
import conditionalSplit from 'cio/app-models/action-abstracts/conditional-split';
import randomCohortSplit from 'cio/app-models/action-abstracts/random-cohort-split';
import createEvent from 'cio/app-models/action-abstracts/create-event';
import createOrUpdatePerson from 'cio/app-models/action-abstracts/create-or-update-person';
import exit from 'cio/app-models/action-abstracts/exit';
import batchUpdate from 'cio/app-models/action-abstracts/batch-update';

export const ACTION_TYPE_TO_ABSTRACT = {
  email_action: message,
  push_action: message,
  slack_action: message,
  twilio_action: message,
  urban_airship_action: message,
  in_app_action: message,
  webhook_action: message,
  create_event_action: createEvent,
  batch_update_action: batchUpdate,
  attribute_update_action: createOrUpdatePerson,
  static_seg_update_action: manualSegmentUpdate,
  collection_query_action: message,
  conditional_wait_action: waitUntil,
  delay_seconds_action: delay,
  delay_time_window_action: timeWindow,
  split_randomized_action: split,
  conditional_branch_action: conditionalSplit,
  multi_split_branch_action: multiSplit,
  random_cohort_branch_action: randomCohortSplit,
  exit_action: exit,
};

export function createActionAbstract(action: ActionModel) {
  let actionTypeAbstracts = ACTION_TYPE_TO_ABSTRACT as any;
  return actionTypeAbstracts[action!.type].create({
    action,
  });
}
